import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";

const HIDE_ON = new Set(["/pricing", "/payment/success", "/billing", "/login", "/register"]);

export default function TrialBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  if (!user || user.role === "admin") return null;
  if (HIDE_ON.has(location.pathname)) return null;

  const status = user.subscription_status;

  if (status === "trialing" && user.days_left != null && user.days_left <= 7) {
    return (
      <div
        className="bg-[#FFC53D] border-b-2 border-[#1C1917] text-[#1C1917] text-xs font-bold flex items-center justify-center gap-2 px-4 py-2"
        data-testid="trial-banner"
      >
        <span>{t("trial_banner", { days: user.days_left })}</span>
        <button
          onClick={() => navigate("/pricing")}
          className="underline underline-offset-2 font-black hover:bg-[#1C1917] hover:text-[#FFC53D] px-2 py-0.5 transition-colors"
          data-testid="trial-banner-cta"
        >
          {t("trial_banner_cta")}
        </button>
      </div>
    );
  }

  if (status === "expired") {
    return (
      <div
        className="bg-[#E5484D] border-b-2 border-[#1C1917] text-white text-xs font-bold flex items-center justify-center gap-2 px-4 py-2"
        data-testid="expired-banner"
      >
        <span>{t("expired_banner")}</span>
        <button
          onClick={() => navigate("/pricing")}
          className="underline underline-offset-2 font-black hover:bg-[#1C1917] hover:text-[#E5484D] px-2 py-0.5 transition-colors"
          data-testid="expired-banner-cta"
        >
          {t("expired_banner_cta")}
        </button>
      </div>
    );
  }

  return null;
}
